import React, { useEffect, useState } from "react";

import { FILTER__FORM_FIELDS_GLOBAL, validatePincode, ignoreFilterItem } from './constants';
import SelectFilterChip from "../studentFinancials/paymentCollection/SelectFilterChip";
import SearchInput from "views/pages/manage/masters/onlinePackage/SearchInput";
import AInput from "../../common/formFeilds/customInput/AInput";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { inputHeight } from "views/pages/manage/edpOps/stockManagement/stockTxns/SearchByOtherDetailsForm";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { FaCheckSquare } from "react-icons/fa";
import { getFilterCount } from "../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { isAlphabet, isNumber } from "../../gateAttendance/constant";


const SearchSchoolForm = ({
    isLoading,
    setIsLoading,
    globalFilter,
    setGlobalFilter,
    isListVisible,
    setListVisible,
    filterType,
    setFilterType,
    selectedFilter,
    setSelectedFilter,
    setFilterCount,
    dropdownData,
    searchHandler,

}) => {

    const callback = () => {
        setGlobalFilter((prev) => FILTER__FORM_FIELDS_GLOBAL);
        setFilterCount(0);
    };

    const onKeyDown = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            applySearchHandler();
        }
    };

    const viewSchoolHandler = () => {
        setFilterCount(getFilterCount({ ...globalFilter }, ignoreFilterItem));
        searchHandler(globalFilter);
    }

    const resetHandler = () => {
        callback();
    }

    const formHandler = (key, value) => {
        setGlobalFilter((prev) => ({ ...prev, [key]: value ?? [], searchValue: "" }));
    };

    const styles = {
        display: "grid",
        gridTemplateColumns:
            "repeat(8,minmax(80px, 1fr)) minmax(130px, 1fr)minmax(50px, 1fr)",
        gap: "16px",
        alignItems: "center",
    };
    const applySearchHandler=()=>{
       const req={
        id: isNumber(globalFilter?.searchValue) ? (globalFilter?.searchValue).trim() : "",
        name: isAlphabet(globalFilter?.searchValue) ? (globalFilter?.searchValue).trim() : "",
       }
       if (req?.id || req?.name){
        searchHandler(req)
       }
    }

    return (
        <>
            <SelectFilterChip
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                cb={callback}
            />

            <div style={{ width: "fit-content" }}>
                <AInput
                    disabled={selectedFilter !== "SINGLE"}
                    placeholder={"Search by school name or ID"}
                    style={{ height: "45px", width: "535px", marginTop: "4px" }}
                    value={globalFilter?.searchValue}
                    handler={(value) => {
                        setGlobalFilter((prev) => ({ ...FILTER__FORM_FIELDS_GLOBAL, ['searchValue']: value }));
                        setFilterType("single");
                    }}
                    onKeyDown={(e) => { onKeyDown(e) }}
                    crossIcon={true}
                    rightSearchIcon={true}
                    searchIconClickHandler={() => {
                        applySearchHandler() }}
                    crossHandler={async () => { setGlobalFilter((prev) => ({ ...prev, searchValue: '' })) }}
                />
            </div>

            <div style={styles} className="mt-4 mb-2">
                <div>
                    <AAutoComplete
                        label="Country*"
                        height={inputHeight}
                        placeholder="Country"
                        isMulti={true}
                        items={dropdownData?.allcountry ?? []}
                        currentValue={globalFilter?.country}
                        isShowCount={true}
                        handleChange={(value) => {
                            formHandler("country", value)
                            setFilterType("bulk");
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>

                {/* <div>
                    <AAutoComplete
                        label="Region*"
                        height={inputHeight}
                        placeholder="Region"
                        isMulti={true}
                        items={dropdownData?.allRegion ?? []}
                        currentValue={globalFilter?.region}
                        isShowCount={true}
                        handleChange={(value) => {
                            formHandler("region", value)
                            setFilterType("bulk");
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div> */}

                <div>
                    <AAutoComplete
                        label="State*"
                        height={inputHeight}
                        placeholder="State"
                        isMulti={true}
                        items={dropdownData?.allState ?? []}
                        isShowCount={true}
                        currentValue={globalFilter?.state}
                        handleChange={(value) => {
                            formHandler("state", value)
                            setFilterType("bulk");
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>

                <div>
                    <AInput
                        value={globalFilter?.pincode}
                        label="Pincode"
                        handler={(value) => {
                            formHandler("pincode", value);
                            setFilterType("bulk");
                        }}
                        placeholder={'Enter pincode'}
                        maxLength={6}
                        disabled={selectedFilter !== "MASTER"}
                        style={{ height: "40px" }}
                        rightCustomIcon={<FaCheckSquare style={{
                            color: (globalFilter?.pincode?.length == 0) ? '#D3D3D3' : '#00B0F5', backgroundColor: '#FFF', fontSize: '20px', top: '3px', right: '5px',
                            position: "absolute",
                            bottom: "0",
                            margin: "auto 0",
                            cursor: globalFilter?.pincode ? "pointer" : "not-allowed",
                        }}
                            onClick={() => validatePincode(setGlobalFilter, globalFilter?.pincode)}
                        />}
                    />

                    {/* <AAutoComplete
                        label="Pincode"
                        height={inputHeight}
                        placeholder="Pincode"
                        isMulti={true}
                        isShowCount={true}
                        items={dropdownData?.board ?? []}
                        currentValue={globalFilter?.board}
                        handleChange={(value) => {
                            formHandler("board", value)
                            setFilterType("bulk");
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    /> */}
                </div>

                <div>
                    <AAutoComplete
                        label="Board"
                        height={inputHeight}
                        placeholder="Board"
                        isMulti={true}
                        isShowCount={true}
                        items={dropdownData?.board ?? []}
                        currentValue={globalFilter?.board}
                        handleChange={(value) => {
                            formHandler("board", value)
                            setFilterType("bulk");
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>

                <div>
                    <AAutoComplete
                        label="Type"
                        height={inputHeight}
                        placeholder="Type"
                        isMulti={true}
                        isShowCount={true}
                        items={dropdownData?.schoolType ?? []}
                        currentValue={globalFilter?.type}
                        handleChange={(value) => {
                            formHandler("type", value)
                            setFilterType("bulk");
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>

                <div>
                    <AAutoComplete
                        label="Status"
                        height={inputHeight}
                        placeholder="Status"
                        isMulti={true}
                        isShowCount={true}
                        items={dropdownData?.schoolStatus ?? []}
                        currentValue={globalFilter?.status}
                        handleChange={(value) => {
                            formHandler("status", value)
                            setFilterType("bulk");
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>

                <div>
                    <AAutoComplete
                        label="Mapped branches"
                        height={inputHeight}
                        placeholder="Mapped branches"
                        isMulti={true}
                        isShowCount={true}
                        items={dropdownData?.allBusinessArea ?? []}
                        currentValue={globalFilter?.mappedBranchIds}
                        handleChange={(value) => {
                            formHandler("mappedBranchIds", value)
                            setFilterType("bulk");
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>

                <div className="d-flex mt-4">
                    <AButton
                        variant={"primary_filled"}
                        onClick={() => { viewSchoolHandler() }}
                        disabled={selectedFilter !== "MASTER" || !(globalFilter?.country?.length && globalFilter?.state?.length)}
                        updatedStyle={{ minWidth: "150px" }}
                    >
                        View schools
                    </AButton>

                    <AButton
                        variant={"danger_filled"}
                        disabled={selectedFilter !== "MASTER" || !(getFilterCount({ ...globalFilter }))}
                        onClick={() => { resetHandler() }}
                    >
                        Reset
                    </AButton>
                </div>
            </div>
        </>
    )
}

export default SearchSchoolForm;   